import React from 'react';

export const AuthorType = ({post}) => {
    return (

        <span style={{
            fontWeight:"400",
            color: "#f8a762"
        }}>
            {post.authorType === "MERCHANT" ? "Owner" : post.authorType === "LOCAL_GUIDE" ? "Local Guide" : ""}
        </span>
    );

}
